import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import appLogger from '../utils/appLogger';

/**
 * Logs app open and route/screen changes to the backend so you can see
 * Android app activity in AWS terminal (pm2 logs). Only sends when on native or REACT_APP_LOG_CLIENT=true.
 */
export default function AppActivityLogger() {
  const location = useLocation();
  const initialMount = useRef(true);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
      appLogger.log('App opened', { action: 'app_start', screen: location.pathname || '/' });
    }
  }, []);

  useEffect(() => {
    if (initialMount.current) return;
    const path = location.pathname || '/';
    const screenName = path === '/' ? 'Home' : path.split('/').filter(Boolean).join('_') || 'Home';
    appLogger.screen(screenName, { path });
  }, [location.pathname]);

  return null;
}
